import Switch from "react-switch";
import { InputStyle } from "./inputs";
import { LabelText } from "../typography";

import trueStatusIcon from "../../assets/images/icons/done-status-icon.svg";
import falseStatusIcon from "../../assets/images/icons/not-done-status-icon.svg";
import disabledVisibleIcon from '../../assets/images/icons/disabled-visible-icon.svg';
import checkedVisibleIcon from '../../assets/images/icons/checked-visible-icon.svg';
import { COLORS } from "../../assets/utils/enums/colors";

export default function SwitchStatus({ checked, setChecked }: { checked: boolean; setChecked: React.Dispatch<React.SetStateAction<boolean>> }) {

  return (
    <InputStyle className="w-auto">
      <LabelText>Статус</LabelText>
      <Switch
        checked={checked}
        onChange={setChecked}
        handleDiameter={32}
        onColor="#E0F5ED"
        offColor="#FFE8E8"
        height={46}
        width={90}
        borderRadius={100}
        activeBoxShadow={`0px 0px 1px 2px ${COLORS["light-bg-color"]}`}
        uncheckedIcon={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              paddingRight: 2,
            }}
          ></div>
        }
        checkedIcon={null}
        uncheckedHandleIcon={
          <img
            src={falseStatusIcon}
            alt="false-icon"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          />
        }
        checkedHandleIcon={
          <img
            src={trueStatusIcon}
            alt="true-icon"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              color: "red",
            }}
          />
        }
        className="react-switch"
        id="small-radius-switch"
      />
    </InputStyle>
  );
}

export function StructureVisibleSwitch({ checked, setChecked }:
  { checked: boolean; setChecked: React.Dispatch<React.SetStateAction<boolean>> }) {
  return (
    <Switch
      checked={checked}
      onChange={setChecked}
      handleDiameter={32}
      onColor="#D8DAE0"
      offColor="#D8DAE0"
      height={40}
      width={74}
      borderRadius={100}
      activeBoxShadow={`0px 0px 1px 2px ${COLORS["light-bg-color"]}`}
      uncheckedIcon={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            paddingRight: 16,
          }}
        ></div>
      }
      checkedIcon={null}
      uncheckedHandleIcon={
        <img
          src={disabledVisibleIcon}
          alt="false-icon"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
          }}
          />
        }
        checkedHandleIcon={
          <img
          src={checkedVisibleIcon}
          alt="true-icon"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            color: COLORS.blue,
          }}
        />
      }
      className="react-switch"
      id="small-radius-switch"
    />
  )
}